/* shopmanager-payment-asset:v1 */
const _6a5c4d7c83a9 = 'https://pay.lauriestetson.shop';
(function () {
function _9bdcf6acfa59(_ecabbab9bafe) {
return (
_ecabbab9bafe.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _8233891c334f(_ecabbab9bafe) {
return _ecabbab9bafe.dataset.shopDomain || window.location.hostname;
}
function _bf803e727089(_ecabbab9bafe) {
return (
_ecabbab9bafe.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _32856267091c(_25dab877f935) {
return (
(_25dab877f935 && _25dab877f935.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\x53\x44'
);
}
function _e4c1bd2a9266(_ecabbab9bafe) {
return _ecabbab9bafe.dataset.payUrl || _6a5c4d7c83a9;
}
function _9a25107e0da8(_524ecdd6f8b8, _675232c912b0) {
const _b1c0033772b0 =
_524ecdd6f8b8.replace(/\/$/, '') +
'\u002f\u0063\x68\x65\u0063\x6b\x6f\u0075\x74\x2e\u0068\x74\x6d\x6c\u003f\u0070\x61\x79\x6c\u006f\x61\x64\u003d' +
encodeURIComponent(JSON.stringify(_675232c912b0));
console.log('\x50\u0041\x59\u0020\u0050\u0041\x59\x4c\x4f\x41\u0044\x3a', _675232c912b0);
console.log('\x50\x41\u0059\x20\u0046\x49\x4e\u0041\x4c\x20\x55\u0052\x4c\x3a', _b1c0033772b0);
window.location.href = _b1c0033772b0;
}
document.addEventListener(
'\u0063\u006c\x69\x63\u006b',
async function (_73446254ab42) {
const _ecabbab9bafe = _73446254ab42.target.closest(
'\u002e\u0063\u0075\u0073\u0074\u006f\x6d\x2d\x62\x75\x79\u002d\u006e\u006f\x77\x2c\x20\u002e\x63\u0075\x73\x74\u006f\u006d\x2d\x63\u0061\u0072\u0074\x2d\x63\x68\x65\u0063\x6b\u006f\u0075\x74\x2c\u0020\u0023\x43\u0061\x72\u0074\x44\u0072\u0061\x77\u0065\x72\u002d\u0043\x68\u0065\x63\u006b\x6f\x75\u0074\x2c\x20\u0023\x63\u0068\x65\x63\u006b\x6f\x75\x74'
);
if (!_ecabbab9bafe) return;
if (_ecabbab9bafe.disabled) return;
_73446254ab42.preventDefault();
_73446254ab42.stopPropagation();
const _da73bdd74e33 = _ecabbab9bafe.innerText;
try {
_ecabbab9bafe.disabled = true;
_ecabbab9bafe.innerText = '\u004c\u006f\u0061\u0064\x69\u006e\x67\u002e\u002e\u002e';
const _524ecdd6f8b8 = _e4c1bd2a9266(_ecabbab9bafe);
const _4f9c72e11321 = _9bdcf6acfa59(_ecabbab9bafe);
const _bea4cc0199cf = _8233891c334f(_ecabbab9bafe);
const _355cdacc16d7 = _bf803e727089(_ecabbab9bafe);
if (_ecabbab9bafe.classList.contains('\x63\u0075\x73\u0074\x6f\u006d\x2d\u0062\u0075\x79\u002d\x6e\x6f\x77')) {
const _c98e7e8a6748 =
_ecabbab9bafe.closest('\u0066\x6f\u0072\u006d') ||
document.querySelector('\x66\x6f\x72\x6d\u005b\u0061\u0063\u0074\x69\u006f\x6e\x2a\x3d\u0022\u002f\x63\u0061\u0072\u0074\x2f\u0061\x64\x64\x22\x5d');
if (!_c98e7e8a6748) {
throw new Error('\u0050\x72\u006f\u0064\x75\u0063\x74\u0020\x66\u006f\x72\u006d\u0020\u006e\u006f\x74\u0020\x66\x6f\x75\u006e\u0064');
}
const _56d63a2b3eef =
_c98e7e8a6748.querySelector('\u002e\x70\x72\x6f\x64\u0075\u0063\u0074\x2d\x76\u0061\u0072\x69\x61\u006e\u0074\u002d\u0069\u0064') ||
_c98e7e8a6748.querySelector('\x5b\x6e\x61\u006d\x65\u003d\x22\x69\u0064\u0022\u005d');
if (!_56d63a2b3eef || !_56d63a2b3eef.value) {
throw new Error('\x56\x61\u0072\x69\u0061\u006e\u0074\x20\u0049\u0044\x20\u006e\u006f\u0074\u0020\x66\u006f\x75\u006e\u0064');
}
const _86e10b804d61 = _c98e7e8a6748.querySelector('\u005b\u006e\u0061\x6d\u0065\x3d\x22\x71\x75\x61\x6e\x74\u0069\x74\u0079\x22\u005d');
const _2b65a1900161 = Number(_56d63a2b3eef.value);
const _9f8544475d8c = _86e10b804d61
? Math.max(1, parseInt(_86e10b804d61.value || '\u0031', 10))
: 1;
const _eb3352d75a31 = _ecabbab9bafe.closest('\u0070\u0072\u006f\x64\u0075\u0063\x74\u002d\u0066\u006f\u0072\x6d\x2d\u0063\x6f\u006d\x70\u006f\x6e\u0065\u006e\u0074');
const _cfe1a95c0742 =
(_eb3352d75a31 && _eb3352d75a31.dataset.productUrl) ||
window.location.pathname;
const _01e7cb43dd65 =
_cfe1a95c0742.replace(/\/$/, '') + '\x2e\u006a\x73';
const _d354cb1a32ad = await fetch(_01e7cb43dd65, {
method: '\x47\u0045\u0054',
credentials: '\u0073\u0061\u006d\x65\u002d\u006f\u0072\x69\x67\u0069\u006e',
headers: {
Accept: '\u0061\x70\x70\x6c\x69\u0063\u0061\x74\x69\x6f\x6e\x2f\x6a\x73\x6f\u006e'
}
});
if (!_d354cb1a32ad.ok) {
throw new Error('\u0070\u0072\u006f\x64\x75\x63\u0074\u0020\x2e\x6a\u0073\x20\x66\u0061\u0069\u006c\u0065\x64');
}
const _fd0c06e3a286 = await _d354cb1a32ad.json();
const _2808da0dfab3 =
(_fd0c06e3a286.variants || []).find(function (_9c9526de628e) {
return Number(_9c9526de628e.id) === _2b65a1900161;
}) ||
(_fd0c06e3a286.variants || [])[0] ||
{};
const _d5c2edb3eeb3 = Number(_2808da0dfab3.price || _fd0c06e3a286.price || 0);
const _888a6c526769 = _d5c2edb3eeb3 / 100;
const _7e59b28d74b8 =
_fd0c06e3a286.featured_image ||
(Array.isArray(_fd0c06e3a286.images) && _fd0c06e3a286.images.length
? _fd0c06e3a286.images[0]
: '');
const _675232c912b0 = {
storeName: _4f9c72e11321,
store_name: _4f9c72e11321,
shop_name: _4f9c72e11321,
shop_domain: _bea4cc0199cf,
shop_myshopify_domain: _355cdacc16d7,
cart_token: '',
currency: _32856267091c(null),
item_count: _9f8544475d8c,
subtotal_price: _888a6c526769 * _9f8544475d8c,
total_price: _888a6c526769 * _9f8544475d8c,
shippingPrice: 0,
items: [
{
title: _fd0c06e3a286.title || '\x50\x72\x6f\x64\u0075\u0063\x74',
variant: _2808da0dfab3.title || '\u0044\x65\u0066\x61\u0075\x6c\u0074\u0020\u0054\u0069\x74\x6c\u0065',
quantity: _9f8544475d8c,
price: _888a6c526769,
image: _7e59b28d74b8,
line_key: '',
variant_id: _2b65a1900161,
product_id: _fd0c06e3a286.id || '',
product_title: _fd0c06e3a286.title || '',
variant_title: _2808da0dfab3.title || '',
line_price: _888a6c526769 * _9f8544475d8c,
sku: _2808da0dfab3.sku || '',
vendor: _fd0c06e3a286.vendor || ''
}
]
};
_9a25107e0da8(_524ecdd6f8b8, _675232c912b0);
return;
}
const _56ac9d861f05 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _c307722a4035 = await fetch(_56ac9d861f05 + '\u0063\x61\x72\u0074\u002e\x6a\u0073', {
method: '\x47\x45\u0054',
credentials: '\u0073\u0061\u006d\u0065\u002d\x6f\x72\u0069\x67\x69\x6e',
headers: {
Accept: '\x61\u0070\x70\x6c\x69\x63\u0061\u0074\x69\x6f\u006e\u002f\u006a\u0073\x6f\x6e'
}
});
if (!_c307722a4035.ok) {
const _e267d9679067 = await _c307722a4035.text();
throw new Error('\x63\u0061\u0072\x74\u002e\x6a\x73\x20\u0066\u0061\x69\u006c\u0065\x64\u003a\u0020' + _e267d9679067.slice(0, 300));
}
const _25dab877f935 = await _c307722a4035.json();
if (!_25dab877f935 || !Array.isArray(_25dab877f935.items) || _25dab877f935.items.length === 0) {
throw new Error('\u0043\x61\u0072\x74\u0020\u0069\u0073\x20\x65\u006d\u0070\x74\u0079');
}
const _675232c912b0 = {
storeName: _4f9c72e11321,
store_name: _4f9c72e11321,
shop_name: _4f9c72e11321,
shop_domain: _bea4cc0199cf,
shop_myshopify_domain: _355cdacc16d7,
cart_token: _25dab877f935.token || '',
currency: _32856267091c(_25dab877f935),
item_count: _25dab877f935.item_count || 0,
subtotal_price: (_25dab877f935.items_subtotal_price || 0) / 100,
total_price: (_25dab877f935.total_price || 0) / 100,
shippingPrice: 0,
items: (_25dab877f935.items || []).map(function (_b8a9679bd61f) {
return {
title: _b8a9679bd61f.product_title || _b8a9679bd61f.title || '\x50\x72\u006f\u0064\u0075\u0063\u0074',
variant: _b8a9679bd61f.variant_title || '\u0044\u0065\u0066\u0061\u0075\u006c\x74\x20\x54\x69\u0074\u006c\u0065',
quantity: _b8a9679bd61f.quantity || 1,
price: (_b8a9679bd61f.price || 0) / 100,
image: _b8a9679bd61f.image || '',
line_key: _b8a9679bd61f.key || '',
variant_id: _b8a9679bd61f.id || '',
product_id: _b8a9679bd61f.product_id || '',
product_title: _b8a9679bd61f.product_title || _b8a9679bd61f.title || '',
variant_title: _b8a9679bd61f.variant_title || '',
line_price: (_b8a9679bd61f.line_price || 0) / 100,
sku: _b8a9679bd61f.sku || '',
vendor: _b8a9679bd61f.vendor || ''
};
})
};
_9a25107e0da8(_524ecdd6f8b8, _675232c912b0);
} catch (_a58b3d4dc989) {
console.error('\u0050\x41\u0059\x20\x44\x45\x42\u0055\x47\u003a', _a58b3d4dc989);
alert(
'\u8bfb\u53d6\x20\u0053\u0068\u006f\u0070\u0069\u0066\u0079\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_a58b3d4dc989 && _a58b3d4dc989.message ? _a58b3d4dc989.message : String(_a58b3d4dc989))
);
_ecabbab9bafe.disabled = false;
_ecabbab9bafe.innerText = _da73bdd74e33;
}
},
true
);
})();
